import { Stack, Typography, useTheme } from "@mui/material";
import { LogOut } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { IconBox } from "web_myplann/Shared/Components/IconBox";
import { useLogOut } from "web_myplann/Shared/Hooks/useLogOut";

export const ProfileLogoutRow: FC = () => {
	const theme = useTheme();
	const { t } = useResource();
	const { logOut } = useLogOut();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={1.6}
			px={1.6}
			py={1.2}
			mt={1.6}
			bgcolor={theme.palette.background.paper}
			onClick={logOut}
			sx={{ cursor: "pointer" }}
		>
			<IconBox bg={theme.palette.red[100]} size={36} shape="circle">
				<LogOut size={theme.iconSize.sm} color={theme.palette.red[600]} />
			</IconBox>
			<Typography variant="body1" color={theme.palette.red[600]}>
				{t(Resources.Profile.Overview.logOut)}
			</Typography>
		</Stack>
	);
};
